export class ConsentAgreementRequiredError extends Error {
  public constructor() {
    super('You must agree to the Notice of Privacy Practices, Informed Consent, and the Terms & Conditions.');
  }
}
